import { createStore } from 'effector';
import { IDataTableRow } from '../models';
import { initRowsEvent, initRowsReducer } from './events/initRowsEvent';

export const $rowsStore = createStore<IDataTableRow[]>([]);

$rowsStore.on(initRowsEvent, initRowsReducer);
